import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Link, Divider, Box } from '@material-ui/core';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';

import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {},
  title: {
    paddingBottom: theme.spacing(6)
  },
  menu: {
    paddingBottom: theme.spacing(6),
    display: 'flex'
  },
  menuButton: {
    paddingRight: theme.spacing(5),
    fontSize: '20px',
    display: 'flex',
    alignItems: 'center'
  },
  menuButtonHover: {
    '&:hover': {
      color: theme.palette.primary.main,
      textDecoration: 'none'
    }
  },
  popUpMenu: {
    zIndex: 2
  },
  active: {
    color: theme.palette.primary.main
  },
  selected: {
    color: theme.palette.primary.main
  }
}));


const NavBar = props => {
  const { options } = props;
  const classes = useStyles();
  const anchorRef = React.useRef([]);
  const [openSubMenu, setOpenSubMenu] = React.useState(null);
  const history = useHistory();

  let activeMenuItem = options.findIndex(option => {
    let url = history.location.pathname;
    let results;

    if (option.dropDown) {
      results =
        option.dropDown.findIndex(menu => {
          return url.includes(menu.go);
        }) > -1;
    }

    if (url.includes(option.go)) {
      results = true;
    }

    return results;
  });

  const handleSubMenuItemClick = (event, option) => {
    setOpenSubMenu(false);
    handleLinkAction(option);
  };

  const handleClose = (event, index) => {
    if (
      anchorRef.current[index] &&
      anchorRef.current[index].contains(event.target)
    ) {
      return;
    }

    setOpenSubMenu(null);
  };

  const handleLinkAction = option => {
    history.push(option.go);
  };

  const handleMenuItemClick = (option, i) => {
    if (option.dropDown ?.length > 0) {
      openSubMenu ? setOpenSubMenu(false) : setOpenSubMenu(i);
      return;
    }
    setOpenSubMenu(null);
    handleLinkAction(option);
  };

  const DropDownMenu = menus => {
    const { index, dropdownOptions } = menus;

    return (
      <Popper
        className={classes.popUpMenu}
        open={openSubMenu === index}
        anchorEl={anchorRef.current[index]}
        role={undefined}
        transition
        disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom'
            }}>
            <Paper>
              <ClickAwayListener
                mouseEvent="onMouseDown"
                touchEvent="onTouchStart"
                onClickAway={event => handleClose(event, index)}>
                <MenuList id="split-button-menu">
                  {dropdownOptions.map((option, i) => (
                    <MenuItem
                      className={option.selected ? classes.selected : ''}
                      key={option.name}
                      onClick={event => handleSubMenuItemClick(event, option)}>
                      {option.name}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    );
  };

  return (
    <div className={classes.root}>
      <Box className={classes.menu}>
        {options.map((option, i) => (
          <React.Fragment key={i}>
            <Link
              key={i}
              ref={el => (anchorRef.current[i] = el)}
              component="button"
              variant="button"
              classes={{
                root: activeMenuItem === i ? classes.active : null,
                underlineHover: classes.menuButtonHover
              }}
              className={classes.menuButton}
              onClick={() => handleMenuItemClick(option, i)}
              underline="hover"
              color="textPrimary">
              {option.name}
              {option.dropDown && (openSubMenu ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />)}
            </Link>
            <DropDownMenu index={i} dropdownOptions={option.dropDown} />
          </React.Fragment>
        ))}
      </Box>
    </div>
  );
};

export default NavBar;
